const bookingCalendarId = "vfeldhnkgkci8n1drquo5qcfn0@group.calendar.google.com"

const getId = () => {
    return bookingCalendarId
}

const _getId = getId;
export { _getId as getId };